export enum TYPE_TOAST {
    ERREUR = 'error',
    AVERTISSEMENT = 'warning',
    INFORMATION = 'info',
    SUCCES = 'success'
}
